import { render, staticRenderFns } from "./EncoderAlerts.vue?vue&type=template&id=22b2b1c7"
import script from "./EncoderAlerts.vue?vue&type=script&lang=js"
export * from "./EncoderAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports